import Vue from "vue";

import currencyService from "../services/currency.service";

Vue.filter("currency", currencyService.format);



// WEBPACK FOOTER //
// ./_common/filters/currency.filter.js